/**
 * useDetailItem — 从已有列表查询缓存中取单条详情
 * 复用列表接口（而非新增 GET /:id），对后端零侵入；
 * 若缓存为空（如直接刷新详情页）会自动重新拉取列表并定位。
 */
import { useQuery } from '@tanstack/react-query'

export function useDetailItem<T>(
  queryKey: unknown[],
  fetcher: () => Promise<T[]>,
  id: string | number,
  idField: keyof T,
) {
  const { data, isLoading, isError } = useQuery({
    queryKey,
    queryFn: fetcher,
  })

  const item = (data ?? []).find(
    (x) => String(x[idField]) === String(id),
  )

  return {
    item: item as T | undefined,
    list: data,
    isLoading,
    isError,
  }
}
